import React, { useEffect, useState } from 'react';
import { locale } from '../../../consts';
import { Endpoint } from '../../../models/api.model';
import { useSnackbar } from '../../../hooks/snackbar';
import { useParams } from 'react-router-dom';
import { useBrandedNavigate } from '../../../hooks/useBrandedNavigate/useBrandedNavigate';
import { Heading } from '../../../components/shared/Heading';
import { Spinner } from '../../../components/shared/Spinner';
import { ITransformedContentPageData, transformContentPageData } from '../../../utils/content';
import { useContentPageGetBySlugQuery } from '../../../libs/graphql/betzoneDirectusAPI/queries/__generated__/content-page-get-by-slug.query.generated';
import { joinStrings } from '../../../utils/string';
import { isCookieFalsy } from '../../../utils/cookies';
import './ContentPage.scss';
import { useUserContext } from '../../../providers/UserProvider';
import { BRANDS } from '../../../components/Itv/types';

export const ContentPage: React.FC = () => {
  const { navigateHome } = useBrandedNavigate();
  const { slug = '', brand = '' } = useParams();
  const { addSnack } = useSnackbar();

  const [transformedContent, setTransformedContent] = useState<ITransformedContentPageData>({ title: '', content: '' });

  const isPolicyPage = transformedContent.title.toLowerCase().includes('policy');

  const handleError = (): void => {
    addSnack({
      type: 'error',
      theme: 'dark',
      message: `Oops, something's gone wrong`,
    });
    navigateHome();

    return;
  };
  const { setTheme } = useUserContext();

  useEffect(() => {
    if (brand) setTheme(brand as BRANDS);
  }, []);
  const { loading } = useContentPageGetBySlugQuery({
    variables: {
      slug,
      language: locale,
    },
    onCompleted: (data) => {
      if (!data.documents.length) {
        return handleError();
      }

      const transformedContentData = transformContentPageData(data);

      setTransformedContent(transformedContentData);
    },
    onError: (error) => {
      console.error(error);

      return handleError();
    },
    context: { endpoint: Endpoint.betzoneDirectusAPI },
  });

  return (
    <>
      {loading ? (
        <div className="spinner-wrapper">
          <Spinner />
        </div>
      ) : (
        <div className={joinStrings(['content-page', isPolicyPage && isCookieFalsy() && 'content-page--overlay'])}>
          {/* TODO: add alternative text from translations instead of empty string if we get a null value (title or content) */}
          <Heading level={1}>{transformedContent.title}</Heading>
          <div dangerouslySetInnerHTML={{ __html: transformedContent.content }} />
        </div>
      )}
    </>
  );
};
